import React from "react";
import { useFilter } from "state/hooks";
import Select from "components/fields/select/Select";
//import PropTypes from 'prop-types';

function SelectFilter(props) {
    const { id, value, onChange, type, label } = props;
    const source = props.source || `api:${type}`;
    return (
        <Select
            type={type}
            value={value[id]}
            onChange={(v) => onChange(id, v)}
            source={source}
            nullable={true}
            label={label}
            variant={"dense"}
        />
    );
}

SelectFilter.defaultProps = {
    value: {},
};

function FloorsFilter(props) {
    const { type } = props;
    const { value, onSet } = useFilter(type);
    const source = value.buildings
        ? `api:apartments.floors?buildings=${value.buildings}`
        : null;
    return (
        <SelectFilter
            id={"floors"}
            type={"apartments.floors"}
            value={value}
            onChange={onSet}
            source={source}
            label={"Piętro"}
        />
    );
}

function BuildingsFilter(props) {
    const { type } = props;
    const { value, onSet } = useFilter(type);
    const source = value.investment
        ? `api:apartments.buildings?investment=${value.investment}`
        : null;
    return (
        <SelectFilter
            id={"buildings"}
            type={"apartments.buildings"}
            value={value}
            onChange={onSet}
            source={source}
            label={"Budynek"}
        />
    );
}

function InvestmentFilter(props) {
    const { type } = props;
    const { value, onSet } = useFilter(type);
    return (
        <SelectFilter
            id={"investment"}
            type={"apartments.investments"}
            value={value}
            onChange={onSet}
            label={"Inwestycja"}
        />
    );
}

function StatusFilter(props) {
    const { type } = props;
    const { value, onSet } = useFilter(type);
    return (
        <SelectFilter
            id={"status"}
            type={"apartments.status"}
            source={"schema:data.flat-status"}
            value={value}
            onChange={onSet}
            label={"Status"}
        />
    );
}

function TypeFilter(props) {
    const { type } = props;
    const { value, onSet } = useFilter(type);
    return (
        <SelectFilter
            id={"type"}
            type={"apartments.type"}
            source={"schema:data.flat-type"}
            value={value}
            onChange={onSet}
            label={"Typ"}
        />
    );
}

export function Filters(props) {
    const {} = props;
    return (
        <div className={"rows gap-sm"}>
            <InvestmentFilter {...props} />
            <BuildingsFilter {...props} />
            <FloorsFilter {...props} />
            <StatusFilter {...props} />
            <TypeFilter {...props} />
        </div>
    );
}

Filters.propTypes = {};

Filters.defaultProps = {};

export default Filters;
